import {
  Box,
  Button,
  Checkbox,
  Fab,
  Grid,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import LibraryAddCheckIcon from "@mui/icons-material/LibraryAddCheck";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ReplyIcon from "@mui/icons-material/Reply";
import React, { useEffect, useRef, useState } from "react";
import { getItems } from "./itemApi";
import ItemCard from "./ItemCard";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import AddItem from "./AddItem";
import { setSnackbar } from "../../app/store/reducer";
import { useDispatch, useSelector } from "react-redux";
import { setPageSizeScreenWise } from "./itemServicesFunction";

// .
import html2pdf from "html2pdf.js";
import SelectedItemsPDFView from "./SelectedItemsPDFView"; // Adjust path as needed

export default function ItemServices({ config }) {
  const [items, setItmes] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, total: 1 });
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [editedItem, setEditedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [selectedItem, setSelectedItem] = useState([]);
  const isLargeScreen = useMediaQuery("(min-width: 1280px)"); // 'lg' breakpoint
  const isMediumScreen = useMediaQuery(
    "(min-width: 960px) and (max-width: 1279px)"
  ); // 'md' breakpoint
  // };
  const [isCheckedAll, setIsChechkedAll] = useState(false);
  // .
  const pdfRef = useRef();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  useEffect(() => {
    let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);
    getItems({ pagination, pageSize }).then((res) => {
      setItmes(res.data.data);
      setPagination({
        page: res.data.pageNumber,
        total: res.data.totalPages,
      });
      setTotalItems(res.data.totalRecords);
    });
  }, []);

  useEffect(() => {
    console.log("selectedit ", selectedItem);
  }, [selectedItem]);
  useEffect(() => {
    let pageSize = setPageSizeScreenWise(isLargeScreen, isMediumScreen);
    getItems({ pagination, search, pageSize }).then((res) => {
      setItmes(res.data.data);
      setPagination({
        ...pagination,
        page: search ? 1 : pagination.page,
        total: res.data.totalPages,
      });
      setTotalItems(res.data.totalRecords);
    });
  }, [pagination.page, search]);
  const handleChange = (event, value) => {
    setPagination({
      ...pagination,
      page: value,
    });
  };

  // .
  const handlePDFExport = async () => {
    const element = pdfRef.current;
    const generateFileName = () => {
      const now = new Date();

      const day = now.getDate().toString().padStart(2, "0");
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const month = monthNames[now.getMonth()];
      const year = now.getFullYear();

      let hours = now.getHours();
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");

      const isPM = hours >= 12;
      const ampm = isPM ? "pm" : "am";
      hours = hours % 12 || 12; // convert to 12-hour format
      const hourStr = hours.toString().padStart(2, "0");

      return `RateCard_${day}-${month}-${year}_${hourStr}-${minutes}-${seconds}_${ampm}.pdf`;
    };

    const fileName = generateFileName();
    const opt = {
      margin: 0.5,
      fileName,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      const pdfBlob = await html2pdf().from(element).set(opt).output("blob");

      const file = new File([pdfBlob], fileName, {
        type: "application/pdf",
      });

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: "Selected Items",
          text: "Here is the selected item list from Palace The Salon",
          files: [file],
        });
      } else {
        const url = URL.createObjectURL(pdfBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "selected-items.pdf";
        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.error("PDF Share Error:", err);
    }
  };
  const headerStyle = {
     fontSize: { xs: "12px", sm: "13px", md: "15px" },
    fontWeight: 500,
    color: "#01008B",
    whiteSpace: "normal",
  };

  const rowTextStyle = {
    fontSize: { xs: "10px", sm: "13px", md: "15px" },
    fontWeight: 500,
    whiteSpace: "normal",
    overflow: "hidden",
    // textOverflow: "ellipsis",
  };

  return (
    <Grid container sx={{ minHeight: "100vh" }}>
      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="center">
          {/* Search Field */}
          <Grid item xs={12} sm={8} md={9}>
            <TextField
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
              placeholder="Search Service/Product"
              variant="outlined"
              fullWidth
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                backgroundColor: "white",
                borderRadius: "6px",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { border: "none" },
                  "&:hover fieldset": { border: "none" },
                  "&.Mui-focused fieldset": { border: "none" },
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#555555",
                  opacity: 0.6,
                  fontWeight: 500,
                },
              }}
              InputLabelProps={{
                className: "mulish",
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
              }}
              InputProps={{
                sx: {
                  color: "#545454",
                  fontWeight: 400,
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  paddingX: "7px",
                },
                endAdornment: (
                  <InputAdornment position="end">
                    {search ? (
                      <CloseIcon
                        onClick={() => setSearch("")}
                        sx={{ cursor: "pointer" }}
                      />
                    ) : (
                      <SearchIcon color="primary" sx={{ cursor: "pointer" }} />
                    )}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>

          {/* Add Button */}
          {config?.addBtn && (
            <Grid item xs={12} sm={4} md={3}>
              <Button
                onClick={() => setOpen(true)}
                fullWidth
                variant="contained"
                color="primary"
                sx={{
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Add Service/Product
                <AddIcon sx={{ ml: 1 }} />
              </Button>
            </Grid>
          )}

          {/* Share Button */}
          {config?.message !== false && (
            <Grid item xs={12} sm={3} md={2}>
              <Button
                onClick={handlePDFExport}
                fullWidth
                variant="contained"
                color="primary"
                sx={{
                  textTransform: "capitalize",
                  whiteSpace: "nowrap",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                Share
                <ReplyIcon sx={{ ml: 1, transform: "scaleX(-1)" }} />
              </Button>
            </Grid>
          )}

          {/* Hidden PDF Component */}
          <Box sx={{ display: "none" }}>
            <SelectedItemsPDFView
              ref={pdfRef}
              items={selectedItem}
              salonInfo={{
                name: userDetail?.myBusinessName,
                address: userDetail?.billerAddress,
                phone: userDetail?.mobileNumber,
                email: userDetail?.mailID1 || "Palacethesalon@gmail.com",
              }}
            />
          </Box>
        </Grid>

        {/* <Grid container>
        <Grid item xs={11}></Grid>
        {(config?.message !== false) && (
          <Grid item xs={1}>
            <Typography color={"secondary"} fontWeight={700}>
              Share{" "}
            </Typography>
            <Typography fontWeight={700}>Select all </Typography>
          </Grid>
        )}
      </Grid> */}
        {/* <Grid container spacing={2} sx={{
        mt: 2, width: "100%",
      }}>
        {items.map((item) => {
          // return null
          return (
            <Grid item lg={3} sm={6} xs={12} md={4}>
              <Paper>
                <ItemCard
                  isCheckBox={config?.isCheckBox}
                  setEditedItem={() => {
                    if (!config?.isCheckBox) {
                      setEditedItem(item);
                      setOpen(true);
                    }
                  }}
                  isCheckedVal={selectedItem?.findIndex((ele) => ele.id == item?.id) != -1}
                  onChangeCheck={(e) => {
                    let arr = [...selectedItem]
                    let indexFind = selectedItem?.findIndex((ele) => ele.id == item?.id)
                    if (indexFind == -1) {
                      setSelectedItem([...selectedItem, item])
                    }
                    else {
                      arr.splice(indexFind, 1)
                      setSelectedItem(arr)
                    }
                  }}
                  item={item}
                />
              </Paper>
            </Grid>
          );
        })}
      </Grid> */}
        <Grid
          container
          sx={{
            p: "10px",
            mt: 2,
            background: "white",
            borderRadius: "12px",
          }}
        >
          <Grid item xs={12}>
            <Box sx={{ overflowX: "auto", width: "100%" }}>
              <Box
                sx={{
                  minWidth: config?.isCheckBox ? "100%" : "100%",
                  width: "100%",
                }}
              >
                {/* Header */}
                <Grid
                  container
                  sx={{
                    borderBottom: "1.5px solid black",
                    py: 1,
                    px: { xs: 1, sm: 10, md: 20, lg: 30 },
                  }}
                >
                  <Grid item xs={config?.isCheckBox ? 4 : 6}>
                    <Typography align="left" sx={headerStyle}>
                      Name of Service and Product
                    </Typography>
                  </Grid>
                  <Grid item xs={config?.isCheckBox ? 4 : 6}>
                    <Typography align="left" sx={headerStyle}>
                      Rate Per Head / NOS
                    </Typography>
                  </Grid>
                  {config?.isCheckBox && (
                    <>
                      <Grid item xs={2}>
                        <Typography align="center" sx={headerStyle}>
                          GST
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Box display="flex" justifyContent="center">
                          <Button
                            variant="outlined"
                            size="small"
                            startIcon={
                              isCheckedAll ? (
                                <LibraryAddCheckIcon />
                              ) : (
                                <CheckBoxOutlineBlankIcon />
                              )
                            }
                            onClick={() => {
                              if (isCheckedAll) {
                                setSelectedItem([]);
                                setIsChechkedAll(false);
                              } else {
                                setSelectedItem([...items]);
                                setIsChechkedAll(true);
                              }
                            }}
                            sx={{
                              textTransform: "none",
                              color: "#01008B",
                              fontWeight: 500,
                              fontSize: { xs: "12px", sm: "13px", md: "13px" },

                              px: 2,
                              py: 0.5,
                              borderWidth: "2px",
                            }}
                          >
                            Select All
                          </Button>
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>

                {/* Data Rows */}
                <Box sx={{ maxHeight: "60vh", overflowY: "auto", mt: 1 }}>
                  {items.map((row) => (
                    <Grid
                      container
                      key={row?.id}
                      alignItems="center"
                      onClick={() => {
                        if (!config?.isCheckBox) {
                          setEditedItem(row);
                          setOpen(true);
                        }
                      }}
                      sx={{
                        borderBottom: "1px solid #eee",
                        backgroundColor: "#E3E3FF",
                        borderRadius: "8px",
                        mb: 1,
                        px: { xs: 2, sm: 10, md: 20, lg: 30 },

                        py: 1,
                        cursor: "pointer",
                      }}
                    >
                      <Grid item xs={config?.isCheckBox ? 4 : 6}>
                        <Typography align="left" sx={rowTextStyle}>
                          {row?.itemDescription || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={config?.isCheckBox ? 4 : 6}>
                        <Typography align="left" sx={rowTextStyle}>
                          {row?.price?.toFixed(2)} / {row?.unit || "N/A"}
                        </Typography>
                      </Grid>
                      {config?.isCheckBox && (
                        <>
                          <Grid item xs={2}>
                            <Typography align="center" sx={rowTextStyle}>
                              {parseFloat(row?.gst).toFixed(2)}%
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Box display="flex" justifyContent="center">
                              <Checkbox
                                onChange={() => {
                                  const index = selectedItem.findIndex(
                                    (ele) => ele.id === row.id
                                  );
                                  const updated = [...selectedItem];
                                  if (index === -1) updated.push(row);
                                  else updated.splice(index, 1);
                                  setSelectedItem(updated);
                                }}
                                checked={
                                  selectedItem.findIndex(
                                    (ele) => ele.id === row.id
                                  ) !== -1
                                }
                              />
                            </Box>
                          </Grid>
                        </>
                      )}
                    </Grid>
                  ))}
                </Box>
              </Box>
            </Box>
          </Grid>

          {/* Add Item Drawer */}
          <AddItem
            open={open}
            item={editedItem}
            setEditedItem={setEditedItem}
            setOpen={setOpen}
            onSave={() => {
              let pageSize = setPageSizeScreenWise(
                isLargeScreen,
                isMediumScreen
              );
              getItems({ pagination, pageSize }).then((res) => {
                setItmes(res.data.data);
                setPagination({
                  page: res.data.pageNumber,
                  total: res.data.totalPages,
                });
                setTotalItems(res.data.totalRecords);
              });
              setOpen(false);
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}
